module.exports = __webpack_public_path__ + "static/media/sticker-image-5.f2d6aadc.png";